module.exports = __webpack_public_path__ + "img/instagram.697c8001.svg";